module.exports = __webpack_public_path__ + "img/iothub.d6106894.jpg";